import { render, staticRenderFns } from "./LandingPageV2.vue?vue&type=template&id=c85736cc&scoped=true"
import script from "./LandingPageV2.vue?vue&type=script&lang=js"
export * from "./LandingPageV2.vue?vue&type=script&lang=js"
import style0 from "./LandingPageV2.vue?vue&type=style&index=0&id=c85736cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85736cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VMain})
